import { SYNTHETIC_DATA_DEMO_ARTIFACT_SECTIONS } from './syntheticDataDemoArtifact.part01.js'

/** @param {string | null | undefined} sectionId */
export function resolveSyntheticDataDemoPdfPage(sectionId) {
  if (!sectionId) return 1
  const section = SYNTHETIC_DATA_DEMO_ARTIFACT_SECTIONS.find((entry) => entry.id === sectionId)
  return section?.page ?? 1
}
